<script>
import moment from "moment";

/*
 * Helps to implement uniform date/time formatting
 */
export default {
  filters: {
    formatTime,
    formatDates,
    objectCount,
    arrayToString,
    trim
  }
};

const TIME_FORMAT = "HH:mm";

const DATE_PART = /[0-9]{4}-[0-9]{2}-[0-9]{2}/i;
const TIME_PART = /[0-9]{2}[:][0-9]{2}[:][0-9]{2}(.[0-9]+)?/i;
const TZ_PART = /Z|[+-][0-9]{2}[:][0-9]{2}/i;

export const DATE_MATCHER = new RegExp(
  `^${DATE_PART.source}(T${TIME_PART.source}(${TZ_PART.source})?)?$`,
  "i"
);
export const DATE_TIME_MATCHER = new RegExp(
  `^${DATE_PART.source}T${TIME_PART.source}(${TZ_PART.source})?$`,
  "i"
);

export function trim(value, length) {
  if (value.length > length) {
    return value.substring(0, length) + "…";
  } else {
    return value;
  }
}

export function isToday(isoDateTime) {
  return moment().isSame(isoDateTime, "day");
}

export function formatTime(isoDate) {
  return isoDate && moment(isoDate).format(TIME_FORMAT);
}

export function formatDates(Value, todaySpecial = "today", DateFormat = "l") {
  if (!Value) {
    return [];
  }
  if (typeof Value === "string") {
    Value = [Value];
  }

  const fmt = DateVal => {
    if (todaySpecial && isToday(DateVal)) {
      return todaySpecial;
    } else {
      return DateVal.format(DateFormat);
    }
  };

  const dates = [...Value];
  dates.sort();
  const ranges = dates.reduce((p, c, idx) => {
    if (idx == 0) {
      p.push({ b: moment(c), e: moment(c), d: 0 });
    } else {
      const m = moment(c);
      const d = m.diff(p[p.length - 1].e, "days");
      if (d === 1) {
        p[p.length - 1].e = m;
        p[p.length - 1].d += 1;
      } else {
        p.push({ b: m, e: m, d: 0 });
      }
    }
    return p;
  }, []);
  const formated = ranges.map(r => {
    if (r.d > 0) {
      return fmt(r.b) + " - " + fmt(r.e) + " (" + (r.d + 1) + ")";
    } else {
      return fmt(r.b);
    }
  });

  return formated;
}

export function objectCount(object) {
  if (!object) {
    return "";
  } else {
    return Object.keys(object).length || 0;
  }
}

export function arrayToString(Value, JoinString = ", ") {
  if (Value instanceof Array) {
    return Value.join(JoinString);
  } else if (!Value) {
    return "";
  } else {
    return Value.toString();
  }
}
</script>
